var App = App || {};

App.Logger = (function () {
    return {
        logAjaxError: logAjaxError
    };

    function logAjaxError(xmlHttpRequest, textStatus) {
        if (window.console) {
            try {
                var err = JSON.parse(xmlHttpRequest.responseText);
                console.error('error: ' + err);
            } catch (e) {
                console.error('Failed to parse error response:', e);
            }
            console.error('status: ' + textStatus);
        }
    }
})(jQuery);